import { type PropsWithChildren } from 'react';
import '../styles.scss';

export function ChatLayout({ children }: PropsWithChildren) {
  return <div className="chat-layout">{children}</div>;
}

export default ChatLayout;
